import { render, staticRenderFns } from "./WorkerCostShiftPage.vue?vue&type=template&id=32a32b79"
import script from "./WorkerCostShiftPage.vue?vue&type=script&lang=js"
export * from "./WorkerCostShiftPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports